import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/artist/importer/artistImporterActions'

export default importerReducers(actions)
